import { createStyles, rem } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: 'inherit',
      backgroundColor: '#EA0029',
      padding: `${rem(8)} ${rem(16)}`,
      '.cs-conversation-header__user-name': {
        backgroundColor: 'transparent',
      },
      '.cs-conversation-header__avatar': {
        width: rem(32),
        height: rem(32),
        marginRight: rem(8),
        '.cs-avatar': {
          width: rem(32),
        },
      },
    },
    info: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(8),
    },
    name: {
      color: '#fff',
    },
    closeBtn: {
      marginRight: rem(-10),
      marginTop: rem(-6),
      marginBottom: rem(-6),
      'svg path': {
        fill: '#fff',
      },
    },
  }
})
